module.exports = __webpack_public_path__ + "static/media/PROCEDURE SINISTRE DEF.2b17cbeb.pdf";